const isNative = fn => {
  return /^s*function \w*\(\)\s*\{\s*\[native code\]\s*\}s*$/.test(`${fn}`);
};

export default isNative;
